<script lang="ts">

    import { navigate } from "svelte-navigator";
    import { Alert, Button, Icon } from "sveltestrap";
    import IconChevron from "../Components/Shared/IconChevron.svelte";
    import View from "../Components/Shared/View.svelte";
    import { currentUser } from "../Services/user";
    import { clearCurrentGame, gameClock, gamePoints, hasSavedGame, isGameCompleted } from "../Services/game"
    import { gamePicturesCount } from "../Services/pictures";
    import { sendEmail } from "../Services/email";
    import { onMount } from "svelte";

    let userEmail: string = null;
    let showSendEmailOk: boolean = false;
    let sendEmailError: boolean = false;
    let isSending = false;

    onMount(() => {
        if (!isGameCompleted()) {
            navigate('/');
        }
    });

    async function sendToEmail(){
        if (isSending || showSendEmailOk) {
            return;
        }
        try {
            isSending = true;
            let code = Math.round(Math.random()*999999);
            await sendEmail(userEmail, '', code, null);

            clearCurrentGame();

            showSendEmailOk = true;
        } catch (error) {
            console.error(error);
            sendEmailError = true;
        } finally {
            isSending = false;
        }
    }

</script>

<style lang="scss">


    .content-info{
        position: relative;
        text-align: center;
        background-color:#fff;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
        width: 75%;
        align-self: center;
    }

    .activity-end {
        position: fixed;
        z-index: 50;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        touch-action: auto;
        pointer-events: auto;
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .header {
        height: 60px;
        display: flex;
        border-bottom: 2px solid grey;
    }

    .close-btn {
        width: 60px;
        height: 60px;
        border: none;
        background-color: transparent;
    }

    .title {
        width: calc(100% - 120px);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        font-size: 1.2rem;
    }

    .icon-people{
        margin: 20px;
    }

    .text-cong{
        font-size: 18px;
    }

    .game-resume {
        padding: 15px;
        width: 100%;
        background-color: #F7F7F7;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        .resume-item {
            display: flex;
            align-items: center;
            gap: 10px;
            font-weight: bold;
            width: 100%;
            max-width: 200px;
        }

        .icon {
            background-color: #B3B3B3;
            color: white;
            width: 44px;
            height: 44px;
            font-size: 20px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

    }

    .info-email{
        margin-top: 15px;
        text-align: center;

        :global(Button){
            width: 100%;
            background-color: var(--color-primary) !important;
            height: 45px;
            font-size: 20px;
            font-weight: 300;
            border-radius: 10px !important;
            margin-bottom: 15px;
        }

        input{
            text-align:center;
            display: block;
            width: 100%;
            height: 45px;
            border-radius: 10px;
            margin-bottom: 15px;
            border-color: #E4E4E4 !important;
        }
    }

</style>

<View flex>

    <div class="activity-end" >
        <div class="header">
            <button type="button" class="close-btn" >
                <IconChevron />
            </button>
            <div class="title">Fin del juego</div>
        </div>
        <div class="content-info">
            
            <div class="icon-people">
                <img src="/images/people-end.png" alt="">
            </div>

            <div class="text-cong">
                {#if $currentUser}
                    <p><strong>¡Felicidades {$currentUser.name}, has completado la misión!</strong></p>
                {/if}
            </div>

            {#if $hasSavedGame}
                <div class="game-resume">
                    <h4 class="resume-title">Tus números:</h4>
                    <div class="resume-item"><div class="icon"><Icon name="clock-history"/></div>{$gameClock}</div>
                    <div class="resume-item"><div class="icon"><Icon name="server"/></div>{$gamePoints} pts</div>
                    <div class="resume-item"><div class="icon"><Icon name="camera-fill"/></div>{$gamePicturesCount} fotos</div>
                </div>
            {/if}

            <div class="info-email">

                {#if !showSendEmailOk}   
                    <p><strong>Te enviaremos tu premio a tu email:</strong></p>
                    <input type="email" bind:value={userEmail} disabled={isSending} placeholder="Escribe tu email">
                    <Button type="button" on:click={sendToEmail} disabled={isSending}>
                        {isSending ? 'Enviando...' : 'Enviar'}
                    </Button>
                {:else}

                    <p><strong>Su email ha sido enviado</strong></p>

                {/if}

                {#if sendEmailError}
                    <Alert color="warning" > Ha ocurrido un error al enviar el email, vuelva a intentarlo </Alert>
                {/if}

                <Button type="button" on:click={() => navigate('/')}> Volver a Jugar </Button>
      
            </div>
        </div>
    </div>


</View>



